import type { AllRouteEndpoints } from "../routeTypes";
export const appGroupsAppGroupIdPlacementsUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/app_groups/:app_group_id/placements/:id",
  "/app_groups/:app_group_id/placements",
];
